import { defineStore } from "pinia";

// type State = {
//   isLoading: boolean;
//   mediaId: number;
//   token: string;
// };

// const state = reactive<State>({
//   isLoading: false,
//   mediaId: 0,
//   token: "",
// });
const appliedProjectScrollHeight = new Map([
  [1, 0],
  [2, 0],
  [3, 0],
]);
type toast = {
  showToast: boolean;
  message: string;
  state: number;
  timeout?: number;
};
const initialToaste: toast = {
  showToast: false,
  message: "",
  state: 0,
  timeout: 2000,
};

export const CommonStore = defineStore("common", {
  state: () => {
    return {
      _isLoading: false,
      _mediaId: 0,
      _token: "",
      _instagram_search_scroll_height: 0,
      _tiktok_search_scroll_height: 0,
      _youtube_search_scroll_height: 0,
      _x_search_scroll_height: 0,
      _applied_project_scroll_height: appliedProjectScrollHeight,
      _document_scroll_height: 0,
      _favorite_scroll_height: 0,
      _toast: initialToaste,
      _updatingToast: initialToaste,
    };
  },

  getters: {
    getMediaId(): number {
      return this._mediaId;
    },

    getToken(): string {
      return this._token;
    },
    getInstagramScrollHeight(): number {
      return this._instagram_search_scroll_height;
    },
    getTiktokScrollHeight(): number {
      return this._tiktok_search_scroll_height;
    },
    getYoutubeScrollHeight(): number {
      return this._youtube_search_scroll_height;
    },
    getXScrollHeight(): number {
      return this._x_search_scroll_height;
    },
    getAppliedProjectScrollHeight(): Map<number, number> {
      return this._applied_project_scroll_height;
    },
    getFavoriteScrollHeight(): number {
      return this._favorite_scroll_height;
    },
    getDocumentScrollHeight(): number {
      return this._document_scroll_height;
    },
    getToast(): toast {
      return this._toast;
    },
    // 応募とかをしてステータスが変わる時一覧更新中の時用↓
    getupDatingToast(): toast {
      return this._updatingToast;
    },
  },
  actions: {
    startLoading() {
      this._isLoading = true;
    },
    endLoading() {
      this._isLoading = false;
    },
    setMediaId(id: number) {
      this._mediaId = id;
    },
    setToken(token: string) {
      this._token = token;
    },
    setInstagramScrollHeight(height: number) {
      this._instagram_search_scroll_height = height;
    },
    setTiktokScrollHeight(height: number) {
      this._tiktok_search_scroll_height = height;
    },
    setYoutubeScrollHeight(height: number) {
      this._youtube_search_scroll_height = height;
    },
    setXScrollHeight(height: number) {
      this._x_search_scroll_height = height;
    },

    setAppliedProjectScrollHeight(index: number, height: number) {
      this._applied_project_scroll_height.set(index, height);
    },
    setDocumentScrollHeight(height: number) {
      this._document_scroll_height = height;
    },
    setFavoriteScrollHeight(height: number) {
      this._favorite_scroll_height = height;
    },
    setToast(toast: {
      showToast: boolean;
      message: string;
      state: number;
      timeout?: number;
    }) {
      this._toast = toast;
    },
    setUpdatingToast(toast: {
      showToast: boolean;
      message: string;
      state: number;
      timeout?: number;
    }) {
      this._updatingToast = toast;
    },
  },
});

export type CommonStore = ReturnType<typeof CommonStore>;
